export default {
    id: "c511eca2-2d70-4d00-af32-b8b54a7cf144",
    icon: "mdi-triangle",
    name: "shapeTriangle",
    title: "Shape Triangle",
    description: "A block triangle",
}